import React from 'react';
import { Calendar } from '@withjoy/joykit/icons';
import { TextV2, Flex } from '@withjoy/joykit';

interface DateProps
  extends Readonly<{
    date: string;
  }> {}

export const Date: React.FC<DateProps> = ({ date }) => {
  return (
    <Flex alignItems="center">
      <Calendar marginRight="8px" />
      <TextV2
        color="mono14"
        typographyVariant="body1"
        fontWeight={400}
      >
        {date}
      </TextV2>
    </Flex>
  );
};
